// eslint-disable-next-line import/no-extraneous-dependencies
import { SxProps } from '@mui/system'
import { Theme } from '@mui/material'

export const styleBtnBlack: SxProps<Theme> = {
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  padding: '9px 12px!important',
  border: '1px solid!important',
  borderRadius: '0!important',
  lineHeight: 1.5,
  backgroundColor: '#000000!important',
  borderColor: '#000000!important',
  color: '#ffffff!important',
  fontWeight: '600',
  '&:hover': {
    backgroundColor: '#333!important',
    borderColor: '#333!important',
    boxShadow: 'none!important',
  },
  '&.MuiLoadingButton-loading': {
    backgroundColor: 'rgb(127, 127, 127)!important',
    borderColor: 'rgb(127, 127, 127)!important',
    color: 'transparent!important',
    '.MuiLoadingButton-loadingIndicator': {
      color: 'white!important',
    },
  },
}

export const styleBtnWhite: SxProps<Theme> = {
  ...styleBtnBlack,
  ...{
    backgroundColor: '#ffffff!important',
    borderColor: '#000000!important',
    color: '#000000!important',
    '&:hover': {
      backgroundColor: '#eee!important',
      borderColor: '#666!important',
      boxShadow: 'none!important',
      color: '#666!important',
    },
  },
}
